import { SiteSectionIds } from '../../../../contentful/constants';
import { AirportCodes } from '../../../../types/airports';

const siteSectionIdToAirportCodeMap: {
	[key in SiteSectionIds]?: AirportCodes;
} = {
	[SiteSectionIds.IAH]: AirportCodes.IAH,
	[SiteSectionIds.HOU]: AirportCodes.HOU,
	[SiteSectionIds.EFD]: AirportCodes.EFD,
	[SiteSectionIds.Spaceport]: AirportCodes.Spaceport,
	[SiteSectionIds.Corporate]: AirportCodes.Corporate,
};

export const getCurrentAirportCodeFromId = (
	currentSiteSectionId?: string | SiteSectionIds,
): AirportCodes =>
	siteSectionIdToAirportCodeMap[currentSiteSectionId as SiteSectionIds] ||
	siteSectionIdToAirportCodeMap[SiteSectionIds.IAH]!;

const airportCodeMap: { [key: string]: AirportCodes } = {
	iah: AirportCodes.IAH,
	hou: AirportCodes.HOU,
	ellington: AirportCodes.EFD,
	spaceport: AirportCodes.Spaceport,
	'airport-business': AirportCodes.Corporate,
};

export const getCurrentAirportCodeFromSlug = (slug: string) => {
	const parts = slug.split('/');
	const airportCodeSlug = parts[1]?.toLowerCase();

	const isStyleguide = parts[1] === 'styleguide';

	if (isStyleguide) {
		return airportCodeMap.iah;
	}

	// The gateway page and anything outside a known section fall back to the
	// airport-business colours; the styleguide is handled above.
	return airportCodeMap[airportCodeSlug] || airportCodeMap['airport-business'];
};
